import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ExportToExcelButton({ hourlyData = [] }) {
  console.log("hourlyData", hourlyData);
  const [loading, setLoading] = useState(false);

  const handleExport = () => {
    if (!Array.isArray(hourlyData) || hourlyData.length === 0) {
      alert("No hourly data available to export");
      return;
    }

    setLoading(true);
    try {
      // Format the data for Excel
      const formattedData = hourlyData.map((item) => ({
        "no of hour": item.hour,
        "No. of Check-in": item.no_of_checkin,
        "No. of Check-out": item.no_of_checkout,
      }));

      // Create workbook & sheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Hourly Data");

      // Save as file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(blob, `checkin_checkout_hourly.xlsx`);
    } catch (error) {
      console.error("Export failed:", error);
      alert("Failed to export data.");
    }
    setLoading(false);
  };

  return (
    <div className="p-3 bg-light rounded">
      <button
        className="btn btn-success"
        onClick={handleExport}
        disabled={loading}
      >
        {loading ? "Exporting..." : "Export Hourly Data"}
      </button>
    </div>
  );
}

export default ExportToExcelButton;
